import { showToast } from "@/flokit/core/toast/show-toast";
import { useRouter } from "next/router";
import { LoadingMask } from "../../../../../../components/loading-mask";
import { openApplicantSignInModal } from "../../../../../../components/molecules/modals/ats/public-sign-in-modal.tsx/verify-email-sign-in-modal";
import { copyTextToClipboard } from "../../../../../../components/utils/clipboard";
import useGetApplicantLoginInfo from "../../../../../../components/utils/useGetApplicantLoginInfo";
import { URLS } from "../../../../../../utils/urls";
import { useGetCareerPageJobDetails } from "../../../../../api-docs";
import { usePublicJobAppQuery } from "../../../../../graphql.types";
import { BaseJobDetailsPane } from "../../../../components/job-details-pane/job-details-pane";
import { isCurrentDateAfterStartDate } from "@/utils/datetime-utils";

export const CandidateJobDetailsPane = (props: {
  org: string;
  jobId: string;
  jobExtension: string;
  allowRequestApplication?: boolean;
  onRequestApplication?: () => void;
  isUpdate?: boolean;
}) => {
  const router = useRouter();
  const { applicantLoginInfo } = useGetApplicantLoginInfo();
  const jobDetailsResponse = useGetCareerPageJobDetails(props.org, props.jobId);
  const candidateJobAppResponse = usePublicJobAppQuery({
    orgFriendlyName: props.org,
    jobExtension: props.jobExtension,
  });

  const job = jobDetailsResponse?.data ?? {
    title: "",
    description: "",
    jobOffices: [],
    positionTypes: [],
    departments: [],
    closeDate: "",
    openDate: "",
    extension: props.jobExtension,
  };

  const existingJobApp =
    candidateJobAppResponse?.data?.publicCandidateJobApp ?? null;

  return (
    <LoadingMask loading={jobDetailsResponse.isLoading}>
      <BaseJobDetailsPane
        title={job.title}
        description={job.description}
        departments={job.departments}
        positionTypes={job.positionTypes}
        offices={job.jobOffices}
        closeDate={job.closeDate}
        openDate={job.openDate}
        allowRequestApplication
        applyButtonDisabled={
          (existingJobApp !== null &&
            existingJobApp.isComplete &&
            existingJobApp.creationType !== "MANUAL" &&
            !props.isUpdate) ||
          !isCurrentDateAfterStartDate(job.openDate)
        }
        onRequestApplication={() => {
          if (!applicantLoginInfo?.success) {
            openApplicantSignInModal();
          } else {
            props.onRequestApplication();
          }
        }}
        onCopyJobLink={() => {
          copyTextToClipboard(
            window.location.host +
              router.basePath +
              URLS.selfApplyJobApplication(props.org, props.jobExtension),
          );
          showToast({
            message: "Copied to clipboard!",
            type: "success",
          });
        }}
        isUpdate={props.isUpdate}
      />
    </LoadingMask>
  );
};
